module.exports = __webpack_public_path__ + "static/media/recover-pass-img.fe97f15d.svg";